/** @ngInject */
export default function UsersEditController(
  $window,
  $stateParams,
  userService,
  UserModel,
  NotificationService,
  UtilService,
  environmentService,
  $state,
) {
  var vm = this;
  vm.isLoading = false;
  vm.availableRoles = [];
  vm.user = $stateParams.user || new UserModel();
  vm.userId = $stateParams.userId;
  vm.password = '';
  vm.passwordConfirmation = '';

  vm.init = init;
  vm.updateUser = updateUser;
  vm.updatePassword = updatePassword;
  vm.deleteUser = deleteUser;
  vm.toggleUserRole = toggleUserRole;

  vm.allowUpdatePassword = false;

  init();

  function init() {
    vm.allowUpdatePassword = !environmentService.isBetaOrProduction();
    getAvailableRoles();
  }

  function updateUser() {
    if (vm.isLoading) {
      return;
    }

    userService
      .updateUser(vm.userId, vm.user)
      .then(function() {
        handleUpdateUser();
      })
      .finally(function() {
        vm.loading = false;
      });
  }

  function updatePassword() {
    if (vm.isLoading || vm.password !== vm.passwordConfirmation) {
      return;
    }

    userService
      .updatePassword(vm.userId, { password: vm.password })
      .then(function() {
        handleUpdateUser();
      })
      .finally(function() {
        vm.loading = false;
      });
  }

  function getAvailableRoles() {
    userService.getAvailableUserRoles().then(function(res) {
      buildAvailableRolesObject(res.data);
      getUser();
    });
  }

  function buildAvailableRolesObject(roles) {
    vm.availableRoles = roles.map(function(role) {
      return { name: role, userHasRole: false };
    });
  }

  function getUser() {
    if (vm.user && vm.user.id === vm.userId) {
      assignUserRoles();
    } else {
      userService.getUser(vm.userId).then(function(res) {
        vm.user = res.data;
        assignUserRoles();
      });
    }
  }

  function assignUserRoles() {
    vm.availableRoles = vm.availableRoles.map(function(role) {
      if (vm.user.roles.indexOf(role.name) >= 0) {
        role.userHasRole = true;
      }

      return role;
    });
  }

  function toggleUserRole(role) {
    UtilService.toggleElementFromArray(vm.user.roles, role.name);
  }

  function deleteUser() {
    if (vm.isLoading) {
      return;
    }

    var confirmation = $window.confirm('Are you sure you want to delete this user?');
    if (confirmation) {
      userService.deleteUser(vm.userId).then(handleDeleteUser);
    }
  }

  function handleUpdateUser() {
    NotificationService.success('The user was successfully updated.');
  }

  function handleDeleteUser() {
    NotificationService.success('The user was successfully deleted.');
    $state.go('app.users', {}, { reload: true });
  }
}



// WEBPACK FOOTER //
// ./src/app/users/users-edit.controller.js